<div (mousemove)="mouseCapture($event)">

<div #container class="vertical-container"  (mousedown)="hidePopover()" >

<div class="graph-box" #graphbox>  

  <div class="range-selector">
    <mat-form-field appearance="fill">
      <mat-label>Categories</mat-label>
      <mat-select (selectionChange)="onTypeSelected()" [(value)]="selectedTypes" multiple>
        <mat-option *ngFor="let type of allTypes" [value]="type">{{type}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="date-picker" appearance="fill" *ngIf="currentRange === 'custom'"  >
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="picker"  (dateChange)="onCustomRangeDateChange($event)" [(ngModel)]="rangeStartDate" placeholder="Choose a date">
      <mat-datepicker-toggle matSuffix  [startAt]="datePickerDate" [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="date-picker" appearance="fill" *ngIf="currentRange === 'custom'"  >
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="picker" (dateChange)="onCustomRangeDateChange($event)" [(ngModel)]="rangeEndDate" placeholder="Choose a date">
      <mat-datepicker-toggle matSuffix  [startAt]="datePickerDate" [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="fill"  class="range-type">
      <mat-label>Range</mat-label>
      <mat-select (selectionChange)="onRangeSelected()" [(value)]="currentRange">
        <mat-option *ngFor="let rangeOption of rangeOptions" [value]="rangeOption.value">
          {{rangeOption.displayName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="data-container">
 
    <div class="results-header" (mousedown)="hidePopover()" *ngIf="readyToRender">
      <div *ngFor="let d of getRelevantTypes(); let i = index" class="object-type-row">
        <div class="label" >{{d}}</div>
      </div>
    </div>

    <div class="results-container" (mousedown)="hidePopover()" *ngIf="readyToRender">
      <div *ngFor="let d of getRelevantTypes(); let i = index" class="object-type-row">
        <div *ngFor="let n of days;  let j = index" class="day-box" >
          <div [ngClass]="getBorderBoxClass(j)">
            <div [ngClass]="getCellClass(d, n)" (mousedown)="showGraphDetail(getTypeFromLabel(d))" (mouseover)="showDay($event, n, d)">
              <div *ngIf="hasMedicationType(n, d)" class="med-indicator"><mat-icon>vaccines</mat-icon></div>
            </div>
          </div>
        </div>
      </div> 
      <div  class="date-row" >
        <div *ngFor = "let n of days" class="date-cell">{{getDateString(n)}}</div>
      </div>


    </div>
  </div>  
</div>


</div>

<div #popover id="popover" >
	<div *ngFor="let item of popoverMap | keyvalue">
  <!-- popover content begin -->
  <div class="popoverItemName" (click)="showGraphDetail(item.key.type, item.key, item.value)">{{item.key.name}} <span *ngIf="item.key.units">{{item.key.units}}</span></div>
  <div *ngIf="isGraphable(item.key.type)">
    <div class="popoverItemData" *ngFor="let data of item.value"><span *ngIf="item.key.type != 'COMPASS_SCORE'">&nbsp;{{data.dateTime | date: 'shortTime'}} </span>{{data.value | number: '1.2-2'}}</div>
 </div>
 <div *ngIf="item.key.type === 'SYMPTOM'">
  <div class="popoverItemData" *ngFor="let data of item.value">{{data.texts[0]}}<span [ngClass]="getSymptomColorStyle(data.value)">&nbsp;{{getSymptomWord(data.value)}}</span></div>
</div>

 <div *ngIf="!isGraphable(item.key.type)">
    <div  *ngFor="let value of item.value">
      <div class="popoverItemData"  *ngFor="let text of value.texts">
         {{text}} 
      </div>
    </div>
 </div>
  <!-- popover content end  -->
  </div>
</div>

</div>